import z from "zod";

/**
 * Shared Zod schema for validating and converting to BigInt instances
 * Accepts string, number, or BigInt inputs and ensures output is always a BigInt
 */
export const BigIntSchema = z.union([
  z.bigint(),
  z
    .string()
    .refine(
      (s) => {
        const num = Number(s);
        return s !== "" && !isNaN(num) && Number.isInteger(num);
      },
      {
        message: "String must be a valid integer number to be parsed to BigInt",
      },
    )
    .transform((s) => BigInt(Number(s))),
  z
    .number()
    .int()
    .transform((n) => BigInt(n)),
]);
